// @ts-expect-error untyped file
import { isStarted } from '../../threads/operators/isStarted';
import { connect } from 'react-redux';

// @ts-expect-error untyped file
import { getGdprConsentToProcessEnabledForChatflow } from '../../gdpr/selectors/getGdprConsentToProcessEnabledForChatflow';
import { shouldRequireExplicitCookieConsent } from '../../selectors/widgetDataSelectors/shouldRequireExplicitCookieConsent';
import { getShowGdprConsentToProcess } from '../../gdpr/selectors/getShowGdprConsentToProcess';
// @ts-expect-error untyped file
import { getSelectedThread } from '../../selected-thread/selectors/getSelectedThread';
import { getShowingHsBranding } from '../../selectors/widgetDataSelectors/getShowingHsBranding';
// @ts-expect-error untyped file
import UnifiedThreadView from '../components/UnifiedThreadView';
// @ts-expect-error untyped file
import { shouldShowMeetingsLink } from '../../meetings-links/selectors/shouldShowMeetingsLink';
import { toggleOnAndOffInputFocus } from '../../actions/inputEventActions';
import { selectAttachmentFile } from '../../file-uploads/actions/selectAttachmentFile';
import { getUserHasGivenConsentToProcess } from '../../gdpr/selectors/getHasUserGivenConsentToProcess';
import { getHasChannelSwitchedToEmail } from '../../threads/operators/threadGetters';
const mapStateToProps = state => {
  return {
    shouldShowMeetingsLink: shouldShowMeetingsLink(state),
    isThreadStarted: isStarted(getSelectedThread(state)),
    requiresExplicitConsentToProcess: getShowGdprConsentToProcess(state),
    showingGdprProcess: getGdprConsentToProcessEnabledForChatflow(state) && !getUserHasGivenConsentToProcess(state),
    renderCookieConsentPrompt: shouldRequireExplicitCookieConsent(state),
    showingHsBranding: getShowingHsBranding(state),
    isThreadTransferred: getHasChannelSwitchedToEmail(getSelectedThread(state))
  };
};
const mapDispatchToProps = {
  toggleOnAndOffInputFocus,
  selectAttachmentFile
};
export default connect(mapStateToProps, mapDispatchToProps)(UnifiedThreadView);